export const SET_ACTIVE_FOOTER_MENU = '@@APP/SET_ACTIVE_FOOTER_MENU';

export const actionCreators = {
    setActiveFooterMenu: (activeFooterMenu) => {
        return ({
        type: SET_ACTIVE_FOOTER_MENU,
        payload: activeFooterMenu
    })
}
};
